/* tslint:disable */
/* eslint-disable */
export enum StepCode {
  Damages = 0,
  Fields = 1,
  Location = 2
}
